window.dtReportMaintenance = function () {
  const dt_report_maintenance = new DataTable('#report-maintenance-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#report-maintenance-datatable').data('source'),
      data: function(d) {
        d.status = ($("#dt-filter-status").val() || "all")
        d.date = ($("#dt-filter-single-date").val() || todayYMD())
      },
      beforeSend: function () { showLoadingRow('#report-maintenance-datatable', 7); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "machine" },
      { "data": "maintenance" },
      { "data": "start" },
      { "data": "end" },
      { "data": "remarks" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1 text-nowrap');
    },
  });

  $(document).off("change", "#dt-filter-single-date, #dt-filter-status")
  $(document).on("change", "#dt-filter-single-date, #dt-filter-status", function(){
    dt_report_maintenance.ajax.reload()
  })

  dtFinalTouch({singleDateFilter: true, openCloseFilter: true})
}
